/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum AppModules {
    ADMIN = 'Admin',
    MY_OFERTEO ='CustomerView'
}
